import axios from '../../../api/axios'

export const fetchJanapratinidhis = async () => {
    return axios.get('/janapratinidhi').then(res=>res.data)
}
